import { Button } from "@shared/ui/Button";
import TestSound from "../../../utils/TestSound";

export type Props = {
  speakerOutput: string;
};

export function TestSpeakersButton({ speakerOutput }: Props) {
  const handleTestSpeaker = () => {
    new TestSound(speakerOutput);
  };

  return (
    <Button variant="secondary" onClick={handleTestSpeaker}>
      Test speakers
    </Button>
  );
}

export default TestSpeakersButton;
